
import React from 'react';
import './closing.scss'
import AudioPlayer from 'react-h5-audio-player';
import 'react-h5-audio-player/lib/styles.css';
import { jae } from '../../assets/audios/jae';
import { jc } from '../../assets/audios/jc';
import { towela } from '../../assets/audios/towela';
import { vin } from '../../assets/audios/vin';

const Closing = () => {
    // async function audioToBase64(audioFile:any) {
    //     return new Promise((resolve, reject) => {
    //       let reader = new FileReader();
    //       reader.onerror = reject;
    //       reader.onload = (e:any) => resolve(e.target.result);
    //       reader.readAsDataURL(audioFile);
    //     });
    //   }
    

    return (
        <div className='closing-wrapper'>
            {/* <input onInput={(e:any)=>audioToBase64(e.target.files[0]).then(result => console.log(result))} type="file"></input> */}
            <div className='heading'>
                <h1>Thank You for Voting. These are your Thunder Mashups.</h1>

                <h3>Get Ready to see them performed Exclusively Live at Mosi Day of Thunder Saturday 26th April 2025 Livingstone</h3>
                {/* <h3>At Mosi day of thunder</h3>
                <h3>Saturday 26 April 2025</h3> */}
            </div>
            <div className='img-wrapper'>
                <div className='img'>
                    <img src="/assets/images/comb/jae_cash_x_76_drums.jpg" />
                    <div className='audio-wrapper'>
                        <AudioPlayer
                            src={jae}
                        />
                        <span className='audio-label'>Jae Cash & 76 Drums - War</span>
                    </div>
                </div>
                <div className='img'>
                    <img src='/assets/images/comb/towela_x_xaven.jpg' />
                    <div className='audio-wrapper'>
                        <AudioPlayer
                            src={towela}
                        />
                        <span className='audio-label'>Towela Kaira & Xaven - Pye Pye</span>
                    </div>
                </div>
                <div className='img'>
                    <img src='/assets/images/comb/vinchenzo_x_chanda_na_kay.jpg' />
                    <div className='audio-wrapper'>
                        <AudioPlayer
                            src={vin}
                        />
                        <span className='audio-label'>Vinchenzo & Chanda Na Kay - Chalila</span>
                    </div>
                </div>
                <div className='img'>
                    <img src='/assets/images/comb/jc_kalinks_x_triple_m.jpg' />
                    <div className='audio-wrapper'>
                        <AudioPlayer
                            src={jc}
                        />
                        <span className='audio-label'>JC Kalinks & Triple M - Nkatumpa</span>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Closing;
